import ConstantApi from '../../../ConstantApi';
import axiosCall from '../../axiosCall';
import { COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET, FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_FAILURE, FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_REQUEST, FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_SUCCESS, FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_FAILURE, FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_REQUEST, FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_SUCCESS, UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_FAILURE, UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_REQUEST, UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_SUCCESS } from './compactingDivAuthorization.actionsType';

export let fetchCompactingAuthorizationData = () => {
    let config = {
        method: 'get',
        // url: `${ConstantApi.knittingDCMasterGET}`,
        url: `${ConstantApi.compactingDivisionAuthorizationGET}`,
        responseTypeRequest: FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_FAILURE

        
    };
    return axiosCall(config);
};

export let UpdateCompactingAuthorizeVerify = (id,checked) => {
    let config = {
        method: 'patch',
        // url: `${ConstantApi.knittingDCMasterGET}`,
        url: `${ConstantApi.compactingDivisionAuthorizationVerify}?FldFKRNNo=${id}&FldIsAuthorized=${checked}`,
        responseTypeRequest: UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_REQUEST,
        responseTypeSuccess: UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_SUCCESS,
        responseTypeFailure: UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_FAILURE,
        resetFormData: COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET,
        getAllData: fetchCompactingAuthorizationData()
        
    };
    return axiosCall(config);
};

export let fetchCompactingDivAuthDetailData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.compactingDivAuthDetailGET}?FldFKRNNo=${id}`,
        responseTypeRequest: FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_REQUEST,
        responseTypeSuccess: FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_SUCCESS,
        responseTypeFailure: FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_FAILURE
    };
    return axiosCall(config);
};